import React, { useEffect, useState } from "react";
import { FooterData, FooterDataRowTwo } from "@/utils/constants/footerLinks";
import styles from "../Footer/Footer.module.scss";

import FooterLinks from "./FooterLinks";
import CopyRight from "../common/CopyRight";
import FooterSocialMedia from "./FooterSocialMedia";
import SubscribeComp from "../common/SubscribeComp";
import Accordion from "../common/Accordion";
import ContactLinks from "./ContactLinks";
import { FooterBuilder } from "../BuilderIO/TickerBanner/TickerBanner.builder";
import { useSelector } from "react-redux";
import { getCookie } from "cookies-next";
import DownloadApp from "../common/DownloadApp";
import { isIOS } from "react-device-detect";
import { reportError } from "@/helpers/errorHelper";
import FooterAppDownload from "./FooterAppDownload";

function Index({ footerRef }) {
  const isPWA = useSelector((state) => state.pwa.is_PWA);
  // const [checkoutId,setCheckoutId] = useState("")
  // For mobile footer links
  const accordionData = FooterData.map((value, index) => {
    return {
      title: (
        <>
          <div className={styles.title_wrapper}>
            <p className="small-xs bold">{value.linkItem.title}</p>
          </div>
        </>
      ),
      headerClass: "",
      body: <FooterLinks footerData={value} key={index} showTitle={false} />,
      icon: {
        src: "images/Icons/Chevron/large.svg",
        alt: "down arrow",
        animationClass: styles.icon_transition,
      },
    };
  });
  const accordionDataTwo = FooterDataRowTwo.map((value, index) => {
    return {
      title: (
        <>
          <div className={styles.title_wrapper}>
            <p className="small-xs bold">{value.linkItem.title}</p>
          </div>
        </>
      ),
      headerClass: "",
      body: <FooterLinks footerData={value} key={index} showTitle={false} />,
      icon: {
        src: "images/Icons/Chevron/large.svg",
        alt: "down arrow",
        animationClass: styles.icon_transition,
      },
    };
  });
  // function to check banner is present or not
  const waitForRewardsBanner = () => {
    return new Promise((resolve) => {
      const checkRewardsBanner = () => {
        const rewardsBanner = document.querySelector(".yotpo-floater-widget-layout");
        // if banner not present calling it again until its present.
        if (rewardsBanner) {
          resolve(rewardsBanner);
        } else {
          setTimeout(checkRewardsBanner, 100);
        }
      };
      checkRewardsBanner();
    });
  };
  // on page load check if the rewards banner exists
  useEffect(() => {
    const checkStickyBanner = async () => {
      try {
        const rewardsBanner = await waitForRewardsBanner();
        document.querySelector(".copyright_wrapper").classList.add("copyright_wrapper_space");
      } catch (error) {
        reportError("Error in check sticky banner")
        reportError(error)
      }
    };
    checkStickyBanner();
  }, []);

  // useEffect(() => {
  //   let cId = getCookie("checkoutId")
  //   cId && setCheckoutId(cId)
  // }, [])

  return (
    <>
      <FooterBuilder />
      {/* {isPWA &&
        <div>
          <span>{checkoutId}</span>
        </div>
      } */}
      {/* show footer only for website */}
      {!isPWA && 
      <div className="container mw-1440 bg-oat pos-relative" ref={footerRef}>
        <div className={styles.footer_padding_top}></div>
        <div className={styles["footer-wrapper"]}>
          <div className={styles["inside-wrapper"]}>
            <div className="row">
              <div className={`grid-xs-12 grid-sm-7 grid-md-6 ${styles.pl_0}`}>
                {/* Desktop View */}
                <div className="row d-xs-none ">
                  {FooterData.map((value, index) => {
                    return (
                      <FooterLinks
                        viewType="desktop"
                        footerData={value}
                        key={index}
                      />
                    );
                  })}
                </div>
                {/* Mobile View */}
                <div className="d-none d-xs-block">
                  <SubscribeComp />
                  <FooterSocialMedia />
                  <FooterAppDownload />
                  <div className="accordion_wrapper">
                    <Accordion data={accordionData} dataTwo={accordionDataTwo} />
                  </div>
                </div>
              </div>
              <div className={`grid-md-2 grid-sm-5 d-xs-none ${styles.pr_0}`}>
                <div className="row">
                  <div className={`grid-xs-12 grid-sm-7 grid-md-7`}>
                    <SubscribeComp />
                    <FooterSocialMedia />
                  </div>
                </div>
              </div>
            </div>
            <div className={`row`}>
              <div className={`grid-xs-12 grid-sm-7 grid-md-6 p-none d-xs-none ${styles.pl_0} footer-second-row`}>
                <div className={`row d-xs-none ${styles.contactLinks_padding_top}`}>
                  {FooterDataRowTwo.map((value, index) => {
                    return (
                      <FooterLinks
                        viewType="desktop"
                        footerData={value}
                        key={index}
                      />
                    );
                  })}
                  <ContactLinks />
                </div>
              </div>
              <div className={`grid-sm-5 grid-md-6 p-none d-xs-none ${styles.pr_0}`}>
                  <FooterAppDownload/>
              </div>
            </div>
          </div>
          <div className={styles["inside-wrapper-contact"]}>
            <div className="row">
              <div className="grid-xs-12 d-md-none">
                <ContactLinks />
              </div>
            </div>
          </div>

          <div className={`${isPWA ? styles.pwa_footer : ''} ${styles.copyright_wrapper} copyright_wrapper`}>
            <CopyRight />
          </div>
        </div>
      </div>
      }
    </>
  );
}

export default Index;